import {Component, ContentChild, Input, TemplateRef} from "@angular/core";
import {UtilsService} from "../../../../services/utils.service";
import {style} from "@angular/animations";

@Component({
  selector: "admin-table-standard",
  templateUrl: "./standard.component.html",
  styleUrls: ["./standard.component.css"]
})
export class TableStandardComponent<T = any> {

  @Input() items: T[] = [];
  @Input() custom: string[] = ["standard-table"];

  @ContentChild("header", { static: true }) headerTemplate!: TemplateRef<any>;
  @ContentChild("first", { static: true }) firstTemplate!: TemplateRef<any>;

  refid: string;

  constructor(
  ) {
    this.refid = UtilsService.generateRandomString()
  }

  protected readonly style = style;
}
